import React from 'react'
import ReactDOM from 'react-dom'

import { I18nextProvider } from 'react-i18next'
import i18n from 'i18next'

import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'

/* Styles */
import index from '../index.html'
import 'style/global.css'

/* Components */
import App from 'component/app/'

import reducer from 'react-redux/reducers/main' // main data entry point

/* Redux Action Logger */
const logger = createLogger({
  collapsed: true
})

import { makeAction } from 'util/reduxhelper'



import createDataProvider from 'util/dataprovider'
import createActionChain from 'util/actionchain'
const dataProvider = createDataProvider() // promised calls for react/redux

import { SUCCESS_SUFFIX, FAIL_SUFFIX, PROGRESS_SUFFIX } from 'util/dataprovider'
const actionChain = createActionChain() // let one action trigger another

import { ERROR, WARNING, STATUS, PROCESS, PROGRESS } from 'component/notification/type'
import {
  push as pushNotification,
  update as updateNotification,
  pull as pullNotification
} from 'react-redux/actions/notification'

const NOTIFICATION_TIMEOUT = 10000 // time in msec



dataProvider.fetch = (context, dispatch, getState) => {
  dispatch(pushNotification({
    uid: context.transactionId,
    type: PROGRESS,
    message: context.type,
    detail: context
  }))
}
dataProvider.fail = (error, context, dispatch, getState) => {
  dispatch(updateNotification({
    uid: context.transactionId,
    type: ERROR,
    message: context.type+FAIL_SUFFIX,
    detail: error
  }))
}
dataProvider.success = (response, context, dispatch, getState) => {
  setTimeout(
    () => {
      dispatch(pullNotification({uid: context.transactionId}))
    },
    NOTIFICATION_TIMEOUT
  )
  dispatch(updateNotification({
    type: STATUS,
    uid: context.transactionId,
    message: context.type+SUCCESS_SUFFIX,
    detail: response,
  }))
}
dataProvider.progress = (progress, context, dispatch, getState) => {
  dispatch(updateNotification({
    type: STATUS,
    uid: context.transactionId,
    progress: progress,
    detail: context
  }))

}



import * as api from 'api'

/* API Util */
import { addResponseMiddleware } from 'api/utils'

/* API Middleware */


import {
  logout
} from 'react-redux/actions/user'
// force logout on 401 Status
addResponseMiddleware((request)=>{
  if(request.error && request.status == 401) {
    store.dispatch(logout())
  }
})

import {
  FETCH_FILTER as APP_FETCH_FILTER,
  SAVE_FILTER as APP_SAVE_FILTER,
  reset as appReset

} from 'react-redux/actions/app'
dataProvider.bind(APP_FETCH_FILTER, api.getGlobalFilter)
dataProvider.bind(APP_SAVE_FILTER, api.updateGlobalFilter)

import {
  fetch as fetchUser,
  FETCH as USER_FETCH,
  LOGIN as USER_LOGIN,
  LOGOUT as USER_LOGOUT,
  REQUEST_PASSWORD_RESET_TOKEN,
  RESET_PASSWORD,
  SAVE_NAME as USER_SAVE_NAME,
  SAVE_SURNAME as USER_SAVE_SURNAME,
  SAVE_PASSWORD as USER_SAVE_PASSWORD,
  FETCH_ORGANIZATION_SCHEDULE as USER_FETCH_ORGANIZATION_SCHEDULE,
  SAVE_ORGANIZATION_SCHEDULE as USER_SAVE_ORGANIZATION_SCHEDULE
} from 'react-redux/actions/user'

dataProvider.bind(USER_FETCH, api.getUserState)
actionChain.chain(USER_FETCH+SUCCESS_SUFFIX, [USER_FETCH_ORGANIZATION_SCHEDULE])
dataProvider.bind(USER_LOGIN, api.login)
actionChain.chain(USER_LOGIN+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(fetchUser())
}])
dataProvider.bind(USER_LOGOUT, api.logout)
actionChain.chain(USER_LOGOUT, [(dispatch, getState, action) => {
  dispatch(appReset())
}])

dataProvider.bind(REQUEST_PASSWORD_RESET_TOKEN, api.requestPasswordResetToken)
dataProvider.bind(RESET_PASSWORD, api.resetPassword)
dataProvider.bind(USER_SAVE_NAME, api.updateUserName)
actionChain.chain(USER_SAVE_NAME+SUCCESS_SUFFIX, [USER_FETCH])
dataProvider.bind(USER_SAVE_SURNAME, api.updateUserName)
actionChain.chain(USER_SAVE_SURNAME+SUCCESS_SUFFIX, [USER_FETCH])
dataProvider.bind(USER_SAVE_PASSWORD, api.updateUserPassword)

dataProvider.bind(USER_FETCH_ORGANIZATION_SCHEDULE, api.getOrganizationConfig)
dataProvider.bind(USER_SAVE_ORGANIZATION_SCHEDULE, api.updateOrganizationConfig)
actionChain.chain(USER_SAVE_ORGANIZATION_SCHEDULE+SUCCESS_SUFFIX, [USER_FETCH_ORGANIZATION_SCHEDULE])

import {
  fetch as fetchLanguage,
  FETCH as LANGUAGE_FETCH,
  SAVE as LANGUAGE_SAVE,
} from 'react-redux/actions/language'

dataProvider.bind(LANGUAGE_FETCH, api.getLanguage)
dataProvider.bind(LANGUAGE_SAVE, api.updateLanguage)
actionChain.chain(LANGUAGE_SAVE+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(fetchLanguage())
}])

import {
  fetchCookieOptIn,
  setView,
  FETCH_COOKIE_OPT_IN,
  SAVE_COOKIE_OPT_IN
} from 'react-redux/actions/app'

dataProvider.bind(FETCH_COOKIE_OPT_IN, api.getCookieOptIn)
dataProvider.bind(SAVE_COOKIE_OPT_IN, api.updateCookieOptIn)
actionChain.chain(SAVE_COOKIE_OPT_IN+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(fetchCookieOptIn())
}])




/* ASSET ACTION API BINDING AND ACTION CHAINING*/

import {
  fetchItems as fetchAssetItems,
  fetchFilter as fetchAssetFilter,
  FETCH_ITEMS as ASSET_FETCH_ITEMS,
  FETCH_ITEM as ASSET_FETCH_ITEM,
  DELETE_SINGLE_ITEM as ASSET_DELETE_SINGLE_ITEM,
  SAVE_NAME as ASSET_SAVE_NAME,
  SAVE_FILE_META_DATA as ASSET_SAVE_FILE_META_DATA,
  SAVE_TAGS as ASSET_SAVE_SAVE_TAGS,
  UPLOAD_FILE as ASSET_UPLOAD_FILE,
  FETCH_FILTER as ASSET_FETCH_FILTER,
  SAVE_FILTER as ASSET_SAVE_FILTER,
  FETCH_SORT as ASSET_FETCH_SORT,
  SAVE_SORT as ASSET_SAVE_SORT,
  CANCEL_UPLOAD as ASSET_CANCEL_UPLOAD
} from 'react-redux/actions/asset'

dataProvider.bind(ASSET_FETCH_ITEMS, api.getAssets)
dataProvider.bind(ASSET_FETCH_ITEM, api.getAsset)
dataProvider.bind(ASSET_DELETE_SINGLE_ITEM, api.removeAsset)
actionChain.chain(ASSET_DELETE_SINGLE_ITEM+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  //dispatch(fetchAssetItems({force: true}))
}])
dataProvider.bind(ASSET_SAVE_NAME, api.updateAssetMetaData)
actionChain.chain(ASSET_SAVE_NAME+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(ASSET_FETCH_ITEM, {uid:action.context.payload.uid}))
}])
dataProvider.bind(ASSET_SAVE_FILE_META_DATA, api.updateAssetMetaData)
actionChain.chain(ASSET_SAVE_FILE_META_DATA+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(ASSET_FETCH_ITEM, {uid:action.context.payload.uid}))
}])
dataProvider.bind(ASSET_SAVE_SAVE_TAGS, api.updateAssetMetaData)
actionChain.chain(ASSET_SAVE_SAVE_TAGS+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(ASSET_FETCH_ITEM, {uid:action.context.payload.uid}))
}])
dataProvider.bind(ASSET_UPLOAD_FILE, api.uploadAsset)
actionChain.chain(ASSET_UPLOAD_FILE+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  const state = getState()
  let tags = []
  const expression = state.app.filter.expression
  if (expression) {
    const matches = expression.match(/#[^ ]+/g)
    if (matches) tags = matches.map(x=>x.replace('#',''))
  }
  dispatch(makeAction(
    ASSET_SAVE_FILE_META_DATA,
    {
      uid:action.payload.id,
      data:{
        name:action.context.payload.name,
        fileName:action.context.payload.name,
        tags
      }
    }
  ))
}])

actionChain.chain(ASSET_CANCEL_UPLOAD, [(dispatch, getState, action) => {
  dataProvider.cancel(action.payload)
}])

dataProvider.bind(ASSET_FETCH_FILTER, api.getAssetFilter)
dataProvider.bind(ASSET_SAVE_FILTER, api.updateAssetFilter)
actionChain.chain(ASSET_SAVE_FILTER+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  //dispatch(fetchAssetFilter())
}])

dataProvider.bind(ASSET_FETCH_SORT, api.getAssetSort)
dataProvider.bind(ASSET_SAVE_SORT, api.updateAssetSort)
actionChain.chain(ASSET_SAVE_SORT+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  //dispatch(fetchAssetFilter())
}])



/* PLAYLIST ACTION API BINDING AND ACTION CHAINING*/

import {
  fetchFilter as fetchPlaylistFilter,
  fetchItems as fetchPlaylistItems,
  fetchItem as fetchPlaylistItem,
  FETCH_ITEMS as PLAYLIST_FETCH_ITEMS,
  FETCH_ITEM as PLAYLIST_FETCH_ITEM,
  CREATE_EMPTY_PLAYLIST as PLAYLIST_CREATE_EMPTY_PLAYLIST,
  DELETE_SINGLE_ITEM as PLAYLIST_DELETE_SINGLE_ITEM,
  SAVE_NAME as PLAYLIST_SAVE_NAME,
  SAVE_TAGS as PLAYLIST_SAVE_TAGS,
  SAVE_START_TIME as PLAYLIST_SAVE_START_TIME,
  SAVE_STOP_TIME as PLAYLIST_SAVE_STOP_TIME,
  DUPLICATE as PLAYLIST_DUPLICATE,
  FETCH_FILTER as PLAYLIST_FETCH_FILTER,
  SAVE_FILTER as PLAYLIST_SAVE_FILTER,
  FETCH_SORT as PLAYLIST_FETCH_SORT,
  SAVE_SORT as PLAYLIST_SAVE_SORT,
} from 'react-redux/actions/playlist'

dataProvider.bind(PLAYLIST_FETCH_ITEMS, api.getPlaylists)
actionChain.chain(PLAYLIST_FETCH_ITEMS+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  //_.each(action.payload, (playlist, uid) => {
    //dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid}))
  //})
}])
dataProvider.bind(PLAYLIST_FETCH_ITEM, api.getPlaylist)
dataProvider.bind(PLAYLIST_CREATE_EMPTY_PLAYLIST, api.addPlaylist)
actionChain.chain(PLAYLIST_CREATE_EMPTY_PLAYLIST+SUCCESS_SUFFIX, [
  (dispatch, getState, action) => {
    dispatch(fetchPlaylistItem(action.payload.id))
  }
  /*(dispatch, getState, action) => {
    dispatch(fetchPlaylistItems({force: true}))
  },*/
])

dataProvider.bind(PLAYLIST_DELETE_SINGLE_ITEM, api.removePlaylist)
actionChain.chain(PLAYLIST_DELETE_SINGLE_ITEM+SUCCESS_SUFFIX, [
  (dispatch, getState, action) => {
    _.each(action.context.opts.affectedAssets, (mediaObject) => {
      dispatch(makeAction(ASSET_FETCH_ITEM, {uid: mediaObject.assetId}))
    })
  },
  //(dispatch, getState, action) => {
  //  dispatch(fetchPlaylistItems({force: true}))
  //},
])
dataProvider.bind(PLAYLIST_SAVE_NAME, api.updatePlaylist)
actionChain.chain(PLAYLIST_SAVE_NAME+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
}])
dataProvider.bind(PLAYLIST_SAVE_TAGS, api.updatePlaylist)
actionChain.chain(PLAYLIST_SAVE_TAGS+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
}])
dataProvider.bind(PLAYLIST_SAVE_START_TIME, api.updatePlaylist)
actionChain.chain(PLAYLIST_SAVE_START_TIME+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
}])
dataProvider.bind(PLAYLIST_SAVE_STOP_TIME, api.updatePlaylist)
actionChain.chain(PLAYLIST_SAVE_STOP_TIME+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  // dispatch(setSyncHintByPlaylist(uid))
}])
dataProvider.bind(PLAYLIST_DUPLICATE, api.addPlaylist)
actionChain.chain(PLAYLIST_DUPLICATE+SUCCESS_SUFFIX, [
  (dispatch, getState, action) => {
    dispatch(fetchPlaylistItems({force: true}))
  }
])

dataProvider.bind(PLAYLIST_FETCH_FILTER, api.getPlaylistFilter)
dataProvider.bind(PLAYLIST_SAVE_FILTER, api.updatePlaylistFilter)
actionChain.chain(PLAYLIST_SAVE_FILTER+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  //dispatch(fetchPlaylistFilter())
}])

dataProvider.bind(PLAYLIST_FETCH_SORT, api.getPlaylistSort)
dataProvider.bind(PLAYLIST_SAVE_SORT, api.updatePlaylistSort)
actionChain.chain(PLAYLIST_SAVE_SORT+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  //dispatch(fetchPlaylistFilter())
}])

/* PLAYLIST MEDIAOBJECT ACTION API BINDING AND ACTION CHAINING*/

import {
  SAVE_ASSET_START_TIME as PLAYLIST_SAVE_ASSET_START_TIME,
  SAVE_ASSET_STOP_TIME as PLAYLIST_SAVE_ASSET_STOP_TIME,
  SAVE_ASSET_DURATION as PLAYLIST_SAVE_ASSET_DURATION,
  SAVE_ASSET_SCHEDULE as PLAYLIST_SAVE_ASSET_SCHEDULE,
  CREATE_PLAYLIST_FROM_ASSET as PLAYLIST_CREATE_PLAYLIST_FROM_ASSET,
  APPEND_ASSET as PLAYLIST_APPEND_ASSET,
  APPEND_ASSET_AT as PLAYLIST_APPEND_ASSET_AT,
  MOVE_ASSET as PLAYLIST_MOVE_ASSET,
  REMOVE_ASSET as PLAYLIST_REMOVE_ASSET,
  REMOVE_AND_APPEND_ASSET as PLAYLIST_REMOVE_AND_APPEND_ASSET,
  REMOVE_AND_INSERT_ASSET as PLAYLIST_REMOVE_AND_INSERT_ASSET,
  appendAsset as playlistAppendAsset,
  appendAssetAt as playlistAppendAssetAt
} from 'react-redux/actions/playlist'

dataProvider.bind(PLAYLIST_SAVE_ASSET_START_TIME, api.updatePlaylist)
actionChain.chain(PLAYLIST_SAVE_ASSET_START_TIME+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  // dispatch(setSyncHintByPlaylist(uid))
}])
dataProvider.bind(PLAYLIST_SAVE_ASSET_STOP_TIME, api.updatePlaylist)
actionChain.chain(PLAYLIST_SAVE_ASSET_STOP_TIME+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  // dispatch(setSyncHintByPlaylist(uid))
}])
dataProvider.bind(PLAYLIST_SAVE_ASSET_DURATION, api.updatePlaylist)
actionChain.chain(PLAYLIST_SAVE_ASSET_DURATION+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  // dispatch(setSyncHintByPlaylist(uid))
}])

dataProvider.bind(PLAYLIST_SAVE_ASSET_SCHEDULE, api.updatePlaylist)
actionChain.chain(PLAYLIST_SAVE_ASSET_SCHEDULE+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  // dispatch(setSyncHintByPlaylist(uid))
}])

dataProvider.bind(PLAYLIST_CREATE_PLAYLIST_FROM_ASSET, api.addPlaylist)
actionChain.chain(PLAYLIST_CREATE_PLAYLIST_FROM_ASSET+SUCCESS_SUFFIX, [
  (dispatch, getState, action) => {
    _.each(action.context.payload.mediaObjects, (mediaObject, index) => {
      dispatch(makeAction(ASSET_FETCH_ITEM, {uid: mediaObject.assetId}))
    })
    // dispatch(setSyncHintByPlaylist(uid))
  },
  (dispatch, getState, action) => {
    dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.payload.id}))
    //dispatch(fetchPlaylistItems({force: true}))
  },

])
dataProvider.bind(PLAYLIST_APPEND_ASSET, api.updatePlaylist)
actionChain.chain(PLAYLIST_APPEND_ASSET+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  dispatch(makeAction(ASSET_FETCH_ITEM, {uid: action.context.payload.assetId}))
  // dispatch(setSyncHintByPlaylist(uid))
}])
dataProvider.bind(PLAYLIST_APPEND_ASSET_AT, api.updatePlaylist)
actionChain.chain(PLAYLIST_APPEND_ASSET_AT+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  dispatch(makeAction(ASSET_FETCH_ITEM, {uid: action.context.payload.assetId}))
  // dispatch(setSyncHintByPlaylist(uid))
}])
dataProvider.bind(PLAYLIST_REMOVE_ASSET, api.updatePlaylist)
actionChain.chain(PLAYLIST_REMOVE_ASSET+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  dispatch(makeAction(ASSET_FETCH_ITEM, {uid: action.context.payload.assetId}))
  // dispatch(setSyncHintByPlaylist(uid))
}])
dataProvider.bind(PLAYLIST_MOVE_ASSET, api.updatePlaylist)
actionChain.chain(PLAYLIST_MOVE_ASSET+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  // dispatch(setSyncHintByPlaylist(uid))
}])
dataProvider.bind(PLAYLIST_REMOVE_AND_APPEND_ASSET, api.updatePlaylist)
actionChain.chain(PLAYLIST_REMOVE_AND_APPEND_ASSET+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(playlistAppendAsset(action.context.payload.target, action.context.payload.assetId))
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  // dispatch(setSyncHintByPlaylist(uid))
}])
dataProvider.bind(PLAYLIST_REMOVE_AND_INSERT_ASSET, api.updatePlaylist)
actionChain.chain(PLAYLIST_REMOVE_AND_INSERT_ASSET+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(playlistAppendAssetAt(action.context.payload.target, action.context.payload.assetId, action.context.payload.targetIndex))
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.uid}))
  // dispatch(setSyncHintByPlaylist(uid))
}])


/* MEDIAPLAYER ACTION API BINDING AND ACTION CHAINING*/

import {
  fetchFilter as fetchMediaPlayerFilter,
  fetchItems as fetchMediaPlayerItems,
  bulkAssignPlaylist,
  FETCH_ITEMS as MEDIAPLAYER_FETCH_ITEMS,
  FETCH_ITEM as MEDIAPLAYER_FETCH_ITEM,
  FETCH_ITEM_STATUS as MEDIAPLAYER_FETCH_ITEM_STATUS,
  FETCH_ITEMS_STATUS as MEDIAPLAYER_FETCH_ITEMS_STATUS,
  FETCH_ITEM_SURFACE as MEDIAPLAYER_FETCH_ITEM_SURFACE,
  FETCH_ITEM_SURFACES as MEDIAPLAYER_FETCH_ITEM_SURFACES,
  SAVE_NAME as MEDIAPLAYER_SAVE_NAME,
  SAVE_DESCRIPTION as MEDIAPLAYER_SAVE_DESCRIPTION,
  SAVE_TAGS as MEDIAPLAYER_SAVE_TAGS,
  FETCH_GRAPHICS_OUTPUT as MEDIAPLAYER_FETCH_GRAPHICS_OUTPUT,
  FETCH_CAMERA_IMAGE as MEDIAPLAYER_FETCH_CAMERA_IMAGE,
  SYNC_MEDIA_PLAYER as MEDIAPLAYER_SYNC_MEDIA_PLAYER,
  SYNC_SURFACES as MEDIAPLAYER_SYNC_SURFACES,
  FETCH_FILTER as MEDIAPLAYER_FETCH_FILTER,
  SAVE_FILTER as MEDIAPLAYER_SAVE_FILTER,
  FETCH_SORT as MEDIAPLAYER_FETCH_SORT,
  SAVE_SORT as MEDIAPLAYER_SAVE_SORT,
  BULK_ASSIGN_PLAYLIST as MEDIAPLAYER_BULK_ASSIGN_PLAYLIST,
  BULK_ASSIGN_ASSET as MEDIAPLAYER_BULK_ASSIGN_ASSET,
  BULK_SYNC as MEDIAPLAYER_BULK_SYNC
} from 'react-redux/actions/media-player'

dataProvider.bind(MEDIAPLAYER_FETCH_ITEMS, api.getMediaPlayers)
actionChain.chain(MEDIAPLAYER_FETCH_ITEMS+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  _.each(action.payload, (item, index) => {
    dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM_STATUS, {uid: item.id}))
    dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM_SURFACES, {uid: item.id}))
  })
}])
dataProvider.bind(MEDIAPLAYER_FETCH_ITEM, api.getMediaPlayer)
actionChain.chain(MEDIAPLAYER_FETCH_ITEM+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
   const {uid} = action.context.payload
   dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM_STATUS, {uid}))
   dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM_SURFACES, {uid}))
}])
dataProvider.bind(MEDIAPLAYER_FETCH_ITEM_STATUS, api.getMediaPlayerStatus)
dataProvider.bind(MEDIAPLAYER_FETCH_ITEMS_STATUS, api.getMediaPlayersStatus)
dataProvider.bind(MEDIAPLAYER_FETCH_ITEM_SURFACES, api.getSurfaces)
dataProvider.bind(MEDIAPLAYER_FETCH_ITEM_SURFACE, api.getSurface)

dataProvider.bind(MEDIAPLAYER_SAVE_NAME, api.updateMediaPlayer)
actionChain.chain(MEDIAPLAYER_SAVE_NAME+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM, {uid: action.context.payload.uid}))
}])
dataProvider.bind(MEDIAPLAYER_SAVE_DESCRIPTION, api.updateMediaPlayer)
actionChain.chain(MEDIAPLAYER_SAVE_DESCRIPTION+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM, {uid: action.context.payload.uid}))
}])
dataProvider.bind(MEDIAPLAYER_SAVE_TAGS, api.updateMediaPlayer)
actionChain.chain(MEDIAPLAYER_SAVE_TAGS+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM, {uid: action.context.payload.uid}))
}])
dataProvider.bind(MEDIAPLAYER_FETCH_GRAPHICS_OUTPUT, api.getMediaPlayerGraphicsOutputImage)
actionChain.chain(MEDIAPLAYER_FETCH_GRAPHICS_OUTPUT+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
}])
dataProvider.bind(MEDIAPLAYER_FETCH_CAMERA_IMAGE, api.getMediaPlayerCameraImage)
actionChain.chain(MEDIAPLAYER_FETCH_CAMERA_IMAGE+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
}])
dataProvider.bind(MEDIAPLAYER_SYNC_MEDIA_PLAYER, api.syncMediaPlayer)
actionChain.chain(MEDIAPLAYER_SYNC_MEDIA_PLAYER+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM, {uid: action.context.payload.uid}))
}])
dataProvider.bind(MEDIAPLAYER_SYNC_SURFACES, api.syncMediaPlayerSurfaces)
actionChain.chain(MEDIAPLAYER_SYNC_SURFACES+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
}])
dataProvider.bind(MEDIAPLAYER_FETCH_FILTER, api.getMediaPlayerFilter)
dataProvider.bind(MEDIAPLAYER_SAVE_FILTER, api.updateMediaPlayerFilter)
actionChain.chain(MEDIAPLAYER_SAVE_FILTER+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  //dispatch(fetchMediaPlayerFilter())
}])
dataProvider.bind(MEDIAPLAYER_FETCH_SORT, api.getMediaPlayerSort)
dataProvider.bind(MEDIAPLAYER_SAVE_SORT, api.updateMediaPlayerSort)
actionChain.chain(MEDIAPLAYER_SAVE_SORT+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  //dispatch(fetchMediaPlayerFilter())
}])

dataProvider.bind(MEDIAPLAYER_BULK_ASSIGN_PLAYLIST, api.bulkAssignPlaylist)
actionChain.chain(MEDIAPLAYER_BULK_ASSIGN_PLAYLIST+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(fetchMediaPlayerItems())
}])

dataProvider.bind(MEDIAPLAYER_BULK_ASSIGN_ASSET, api.addPlaylist)
actionChain.chain(MEDIAPLAYER_BULK_ASSIGN_ASSET+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.payload.id}))
  dispatch(bulkAssignPlaylist(action.payload, action.context.opts.filter))
}])

dataProvider.bind(MEDIAPLAYER_BULK_SYNC, api.bulkSyncMediaPlayer)
actionChain.chain(MEDIAPLAYER_BULK_SYNC+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
}])

import {
  assignPlaylist as surfaceAssignPlaylist,
  assignGlobalPlaylist as surfaceAssignGlobalPlaylist,
  REMOVE_ASSIGNMENT as SURFACE_REMOVE_ASSIGNMENT,
  ASSIGN_PLAYLIST as SURFACE_ASSIGN_PLAYLIST,
  WRAP_ASSET_AND_ASSIGN_PLAYLIST as SURFACE_WRAP_ASSET_AND_ASSIGN_PLAYLIST,
  ASSIGN_GLOBAL_PLAYLIST as SURFACE_ASSIGN_GLOBAL_PLAYLIST,
  WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST as SURFACE_WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST,
  SAVE_NAME as SURFACE_SAVE_NAME
} from 'react-redux/actions/surface'

dataProvider.bind(SURFACE_REMOVE_ASSIGNMENT, api.updateSurface)
actionChain.chain(SURFACE_REMOVE_ASSIGNMENT+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  if(action.context.opts.previousPlaylistId) dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.opts.previousPlaylistId}))
  dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM_SURFACE, {mediaPlayerId: action.context.payload.mediaPlayerId, surfaceId: action.context.payload.surfaceId}))
}])

dataProvider.bind(SURFACE_ASSIGN_PLAYLIST, api.updateSurface)
actionChain.chain(SURFACE_ASSIGN_PLAYLIST+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  if (action.context.opts.previousPlaylistId) dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.opts.previousPlaylistId}))

  dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: action.context.payload.surface.playlistId}))
  dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM_SURFACE, {mediaPlayerId: action.context.payload.mediaPlayerId, surfaceId: action.context.payload.surfaceId}))
}])

dataProvider.bind(SURFACE_WRAP_ASSET_AND_ASSIGN_PLAYLIST, api.addPlaylist)
actionChain.chain(SURFACE_WRAP_ASSET_AND_ASSIGN_PLAYLIST+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(fetchPlaylistItems({force: true}))
  dispatch(surfaceAssignPlaylist(action.context.opts.mediaPlayerId, action.context.opts.surfaceId, action.payload.id))
}])

actionChain.chain(SURFACE_ASSIGN_GLOBAL_PLAYLIST, [(dispatch, getState, action) => {
  // WORKAROUND. BULK UPDATE API METHOD DOES NOT EXIST ANYMORE
  for (var k in action.payload.surfaces) {
    dispatch(surfaceAssignPlaylist(action.payload.mediaPlayerId, k, action.payload.surfaces[k].playlistId))
  }
}])

dataProvider.bind(SURFACE_WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST, api.addPlaylist)
actionChain.chain(SURFACE_WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(fetchPlaylistItems({force: true}))
  dispatch(surfaceAssignGlobalPlaylist(action.context.opts.mediaPlayerId, action.payload.id))
}])

/*
// DOES NOT WORK. DUE TO API CHANGES
dataProvider.bind(SURFACE_ASSIGN_GLOBAL_PLAYLIST, api.updateSurfaces)
actionChain.chain(SURFACE_ASSIGN_GLOBAL_PLAYLIST+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  if(action.context.opts.previousPlaylists) {
    action.context.opts.previousPlaylists.each((playlistId) => {
      dispatch(makeAction(PLAYLIST_FETCH_ITEM, {uid: playlistId}))
    })
  }
  dispatch(surfaceAssignPlaylist(action.context.opts.mediaPlayerId, action.context.opts.surfaceId, action.payload.id))
}])*/

dataProvider.bind(SURFACE_SAVE_NAME, api.updateSurface)
actionChain.chain(SURFACE_SAVE_NAME+SUCCESS_SUFFIX, [(dispatch, getState, action) => {
  dispatch(makeAction(MEDIAPLAYER_FETCH_ITEM_SURFACE, {mediaPlayerId: action.context.payload.mediaPlayerId, surfaceId: action.context.payload.surfaceId}))
}])


/* Global Redux Store */
const store = createStore(
  reducer,
  applyMiddleware(
    thunk // lets us dispatch() functions
    , dataProvider
    , actionChain
    //, logger // logs all redux actions. Must be last in chain!
  )
)

/* Monitor user status */
import * as Taskrunner from 'util/taskrunner'
let loginStateMonitoringTask
const LOGIN_STATE_MONITORING_INTERVAL = 3e4
if (!loginStateMonitoringTask) {
  loginStateMonitoringTask = Taskrunner.addTask(
    (task) => {
      store.dispatch(fetchUser())
    },
    (task) => {
      if(!store.getState().user.loggedIn) return false
      if( Date.now() - task.lastRun > LOGIN_STATE_MONITORING_INTERVAL ) {
        return true
      }
      return false
    }
  )
}

import conf from 'i18n/conf.json'
i18n.init(conf)
let currentLanguage
store.subscribe(() => {
  const currentState = store.getState()
  // lng
  let previousLanguage = currentLanguage
  currentLanguage = currentState.user.language
  if (previousLanguage !== currentLanguage) {
    i18n.init({ lng: currentLanguage })
  }
  //
})


import { getParam } from 'util/url'
import * as VIEW from 'component/app/view'
var resetToken = getParam('reset_token')
if (resetToken) {
  store.dispatch(setView(VIEW.PASSWORDRESET))
}


function getBrand() {
  let url_string = window.location.href
  let url = new URL(url_string);
  let brand = url.searchParams.get("brand");
  if (brand) return brand
  return "light-instruments"
}

import {
  SET_LOGO
} from 'react-redux/actions/brand'
store.dispatch(makeAction(SET_LOGO, {logo:getBrand()}))

function injectLanguage() {
  let url_string = window.location.href
  let url = new URL(url_string);
  let lang = url.searchParams.get("lang");
  if (lang && (lang === "en" || lang === "de")) {
    api.updateLanguage(lang)
  }
}
injectLanguage()




/* Initial React render call and Entry Point */
ReactDOM.render(
  <I18nextProvider i18n={ i18n }>
    <Provider store={ store }>
      <App/>
    </Provider>
  </I18nextProvider>,
  document.getElementById('app') // see index.html
)



// WEBPACK FOOTER //
// ./src/app/main/entry.jsx